import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {IPageData, UIError} from 'common/interfaces';
import {IStore, IStoreState} from 'common/interfaces/istore';

const initialStoreState: IStoreState = {
  loading: false,
  error: null,
  stores: null,
} as IStoreState;

const reducers = {
  setLoading: (state: IStoreState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: IStoreState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IStoreState) => {
    state.error = initialStoreState.error;
    state.stores = initialStoreState.stores;
    state.loading = initialStoreState.loading;
  },
  setStores: (
    state: IStoreState,
    action: PayloadAction<IPageData<IStore> | null>,
  ) => {
    state.stores = action.payload;
  },
  addStores: (
    state: IStoreState,
    action: PayloadAction<IPageData<IStore> | null>,
  ) => {
    if (action.payload) {
      const stStores = state.stores?.items || [];
      const payLoadStores = action.payload.items || [];
      state.stores = {
        ...action.payload,
        items: [...stStores, ...payLoadStores],
      };
    }
  },
  // setPageInfo: (
  //   state: IStoreState,
  //   action: PayloadAction<IPageInfo | null>,
  // ) => {
  //   // state.pagingInfo = action.payload;
  // },
};

const storeSlice = createSlice({
  name: 'IStoreState',
  initialState: initialStoreState,
  reducers: reducers,
});

export default storeSlice.reducer;
export const StoreActions = storeSlice.actions;
